module.exports = __webpack_public_path__ + "static/media/message.2081e554.svg";